import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { Chart } from "react-google-charts";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mobile: { minWidth: "1200px", height: "450px" },
    desktop: { minWidth: "100%" },
  })
);

export default function ChartCombo(propsCom: ChartComboProps) {
  const styleGraphics = useStyles();

  return (
    <div className={window.screen.width < 1000 ? styleGraphics.mobile : styleGraphics.desktop}>
      <Chart
        // width={`${props.widthVal}px`}
        height={propsCom.descripcionH === "Mes" ? "300px" : "500px"}
        chartType="ComboChart"
        loader={
          <img
            height="150"
            width="150"
            src="https://mir-s3-cdn-cf.behance.net/project_modules/disp/35771931234507.564a1d2403b3a.gif"
            alt=""
          ></img>
        }
        data={propsCom.data}
        options={{
          title: propsCom.title,
          vAxis: { title: propsCom.descripcionV },
          hAxis: { title: propsCom.descripcionH },
          seriesType: "bars",
          // series: props.series ,
        }}
        chartEvents={[
          {
            eventName: "ready",
            callback: ({ chartWrapper, props }) => {
              const chart = chartWrapper.getChart().getImageURI();
              propsCom.getImage(chart);
            },
          },
        ]}
        rootProps={{ "data-testid": "1" }}
      />
    </div>
  );
}

interface ChartComboProps {
  data: Array<any>;
  series: any;
  title: string;
  descripcionH: string;
  descripcionV: string;
  getImage(img: any): void;
}

ChartCombo.defaultProps = {
  title: "Resoluciones por mes",
  descripcionH: "Mes",
  descripcionV: "Resoluciones",
};
